import { render, staticRenderFns } from "./RecollectFilter.vue?vue&type=template&id=1c0a68d8&scoped=true"
import script from "./RecollectFilter.vue?vue&type=script&lang=js"
export * from "./RecollectFilter.vue?vue&type=script&lang=js"
import style0 from "./RecollectFilter.vue?vue&type=style&index=0&id=1c0a68d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0a68d8",
  null
  
)

export default component.exports